<template>
  <div class="student">
    <el-card class="box-card" style="margin-top: 20px;">
      <div class="saleRowBox">
        <div class="asideSwitch">
          <div class="saleT mb20">营销中心</div>
          <div @click="tabClick(item)" :class="tabAcName == item.name ? 'tabItem tabAc mb20' : 'tabItem mb20'" v-for="item in tabArr" :key="item.name">{{ item.label }}</div>
        </div>
        <div class="mainContent" v-if="tabAcName == 'coupon'">
          <div class="tipsGray">优惠券：可以设置无门槛优惠券，也可以满一定金额优惠，创建后可以增加优惠券发放数量</div>
          <coupon-sale ref="couponSale"></coupon-sale>
        </div>
        <div class="mainContent" v-if="tabAcName == 'flashSale'">
          <div class="tipsGray">限时折扣：在节日或者特殊时期可以给商品设置优惠价，过了时间就恢复原价</div>
          <sale-limit ref="saleLimit"></sale-limit>
        </div>
        <div class="mainContent" v-if="tabAcName == 'groupReserve'">
          <div class="tipsGray">拼团：多个客户购买时可以享受拼团优惠</div>
          <group-reserve ref="groupReserve"></group-reserve>
        </div>
        <div class="mainContent" v-if="tabAcName == 'oneCentCourse'">
          <div class="tipsGray">一元好课：设置低价商品进行引流，建议选取入门课或者训练营</div>
          <one-cent-course ref="oneCentCourse"></one-cent-course>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import saleLimit from './saleLimit.vue'
import couponSale from './couponSale.vue'
import groupReserve from './groupReserve.vue'
import oneCentCourse from './oneCentCourse.vue'
import md5 from "md5";
export default {
  components: { saleLimit, couponSale, groupReserve, oneCentCourse },
  data () {
    return {
      couponForm: {
        couponType: '',
      },
      tabAcName: 'coupon',
      tabArr: [{
        label: '优惠券',
        name: 'coupon'
      }, {
        label: '限时折扣',
        name: 'flashSale'
      }, {
        label: '拼团',
        name: 'groupReserve'
      }, {
        label: '一元好课',
        name: 'oneCentCourse'
      }],
      activityId: '',
      activeName: 'first',
      catogeryList: [
        {
          label: '活动列表',
          name: 'first'
        }, {
          label: '创建限时折扣',
          name: 'second'
        }
      ],
      couponAcName: 'first',
      couponArray: [{
        label: '活动列表',
        name: 'first'
      }, {
        label: '创建优惠券',
        name: 'second'
      }],
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      viewFormVisible: false,
      addFormVisible: true,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        name: "",
        createTime: "",
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },

      editForm: {
        account: "",
        name: "",
        sex: "",
        card: "",
        email: "",
        address: "",
        remark: "",
      },
      studentDetail: {},
      editFormRules: {
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确",
          },
        ],
        studentGroupId: [
          {
            required: true,
            message: "请选择学员分组",
            trigger: "blur",
          },
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字",
          },
        ],

        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "100px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
      createList: [],
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    tabClick (obj) {
      this.tabAcName = obj.name
      this.page.pageNumber = 1;
      if (this.tabAcName == 'coupon') {
      } else if (this.tabAcName == 'flashSale') {
      }
    },

  },
  watch: {

  },
  mounted () {
  },
};
</script>
<style scoped>
.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less" >

.student {
  .el-select {
    width: 100% !important;
  }

  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 0px !important;
    }
  }

  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}

.goodBox {
  display: flex;
}

.priceGods {
  display: flex;
  flex-direction: column;
}

.goodsImg {
  width: 120px;
  height: 90px;
}

.btnCenter {
  display: flex;
  margin: 20px 0;
  justify-content: center;
}

.tipsGray {
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 14px;
  color: rgb(16, 16, 16);
  font-style: normal;
  text-decoration: none;
  height: 35px;
  line-height: 35px;
  background: rgb(238, 236, 236);
  padding: 0 15px;
  box-sizing: border-box;
}

.saleRowBox {
  display: flex;

  .asideSwitch {
    width: 160px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;

    .saleT {
      font-family: SourceHanSansSC;
      font-weight: 700;
      font-size: 14px;
      color: rgb(16, 16, 16);
      font-style: normal;
      letter-spacing: 0px;
      line-height: 20px;
      text-decoration: none;
    }

    .tabItem {
      width: 100px;
      height: 30px;
      cursor: pointer;
      color: rgb(100, 95, 95);
      border-radius: 4px;
      line-height: 30px;
      border: 1px solid rgb(187, 187, 187);
      font-size: 14px;
      text-align: center;
      font-weight: normal;
      font-style: normal;
      background: rgb(255, 255, 255);
    }

    .tabAc {
      color: rgb(255, 255, 255);
      background: rgb(164, 173, 179);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/conentSaleCenter/flashSale.vue